import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import queryString from "query-string";
import { auth, firestore, Timestamp } from './firebase';
import { UserContext } from './providers/UserProvider';
import searchInCollection from "./search";

export default function Sidebar({ newItem, newItemText, collection, showSearch, itemTitle, itemSubtitle, itemLink, orders, defaultOrder, filters, defaultOpen }) {
    const history = useHistory();
    const location = useLocation();


    const [queryParams, setQueryParams] = useState({});
    const [order, setOrder] = useState(orders?.find(e => e.id === defaultOrder));
    const [open, setOpen] = useState(defaultOpen??true);
    const [items, setItems] = useState([]);
    const [limit, setLimit] = useState(30);
    const [search, setSearch] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => setQueryParams(queryString.parse(location.search)), [location.search]);
    useEffect(() => setOrder(orders?.find(e => e.id === (queryParams?.order??defaultOrder))), [defaultOrder, queryParams]);
    useEffect(() => {
        if(search) return;
        if(!collection) return;
        let q = firestore.collection(collection);
        if(order) q = q.orderBy(order.field, order.direction);
        if(order?.fromNow) q = q.where(order.field, order.direction === 'asc' ? '>' : '<', Timestamp.now());
        for(const filter of filters??[]) {
            if(queryParams[filter.id]) {
                q = q.where(filter.field, filter.type === 'equals' ? '==' : filter.type, queryParams[filter.id]);
            }
        }
        q.limit(limit).get().then(({docs}) => setItems(docs.map((e) => ({objectID: e.id, ...e.data()}))));
    }, [collection, order, limit, filters, queryParams, search]);
    useEffect(() => { search && searchInCollection(search, collection).then(hits => setItems(hits)) }, [search]);
    useEffect(() => {
        window.addEventListener('resize', () => setWidth(window.innerWidth));
        return () => {
            window.removeEventListener('resize', () => setWidth(window.innerWidth));
        }
    }, []);

    const scroll = (e) => {
        if(e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 100 && items.length === limit)
            setLimit(limit + 30);
    }

    const sortItems = (items) => {
        if(!order) return items;
        items = items.sort((a, b) => {
            let aValue = a[order.field];
            let bValue = b[order.field];
            aValue = aValue?._seconds??aValue;
            bValue = bValue?._seconds??bValue;
            if(order.direction === 'asc') return aValue - bValue;
            else return bValue - aValue;
        });
        if(order.fromNow) {
            items = items.filter(e => {
                const now = Math.round(Date.now() / 1000);
                const seconds = e[order.field]?._seconds??e[order.field]?.seconds??0;
                return order.direction === 'asc' ? seconds > now : seconds < now;
            });
        }
        for(const filter of filters??[]) {
            if(queryParams[filter.id]) {
                items = items.filter(e => {
                    switch(filter.type) {
                        case 'array-contains': return e[filter.field]?.includes(queryParams[filter.id])??false;
                        case 'equals': return e[filter.field] === queryParams[filter.id];
                        default: return true;
                    }
                });
            }
        }
        return items;
    };

    // Only fpr changelogs
    const handleMenuClick = () => {
        if(!window.location.pathname.includes("/changelogs")) return
        if(document.getElementById("submenu") && open === false) {
            document.getElementById("submenu").classList.remove("hidden");
        }
        else if(document.getElementById("submenu") && open === true) {
            document.getElementById("submenu").classList.add("hidden");
        }
    }

    return open || width > 768 ? <div className="w-screen md:w-auto h-full flex text-white">
        <div className="overflow-hidden w-60 bg-black h-full flex-col flex">
            <div className="flex p-2 justify-between">
                {width <= 768 && <div className="m-2 font-semibold" onClick={(_) => {setOpen(false);handleMenuClick()}}>
                    ☰
                </div>}
                <div className="font-bold text-lg text-center p-3">
                    WoGehtWas Admin
                </div>
            </div>
            <div className="grow-1 min-h-0 overflow-y-scroll">
                <div className="font-semibold text-lg p-3 mt-5">
                    Events
                </div>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/events">
                    Datenbank
                </NavLink>
                {/* <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/organizers">
                    Veranstalter
                </NavLink>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/locations">
                    Locations
                </NavLink>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/artists">
                    Künstler
                </NavLink> */}
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/upcoming">
                    Kalender
                </NavLink>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/updates">
                    Neues vom Formular
                </NavLink>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/link-sticker">
                    Link-Sticker
                </NavLink>
                <div className="font-semibold text-lg p-3 mt-5">
                    Einstellungen
                </div>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/settings/emails">
                    Email-Benachrichtigungen
                </NavLink>
                <NavLink className="flex block p-3 pl-8 text-gray-300" activeClassName="bg-gray-800" to="/settings/account">
                    Kontoeinstellungen
                </NavLink>
            </div>
            <button className="flex block p-3 mt-5 bg-red-500 justify-center mt-auto text-lg font-semibold" onClick={(_) => auth.signOut()}>
                Ausloggen
            </button>
        </div>
        {itemTitle && <div className="w-full md:w-64 bg-gray-800 h-full flex-col flex">
            {newItem && <button className="flex block p-3 font-semibold bg-green-500 justify-center items-center" onClick={() => newItem() && setOpen(false)}>
                <div>{newItemText??'Neu'}</div>
                <div className="ml-2">+</div>
            </button>}
            {orders && <div className="flex block p-3 bg-gray-600">
                Sortieren:
                <select className="bg-gray-600 ml-2 w-full" value={queryParams.order??defaultOrder} onChange={(e) => history.replace({pathname: location.pathname, search: '?' + new URLSearchParams({...queryParams, order: e.target.value}).toString()})}>
                    {orders.map(e => <option value={e.id}>{e.label}</option>)}
                </select>
            </div>}
            {filters?.filter(e => queryParams[e.id])?.map(e => <div className="flex block p-3 bg-gray-600">
                <div className="text-ellipsis whitespace-nowrap overflow-hidden">{e.label}: {queryParams[e.id]}</div>
                <div className="ml-3 font-semibold cursor-pointer" onClick={_ => history.replace({pathname: location.pathname, search: '?' + new URLSearchParams({...queryParams, [e.id]: ''})})}>X</div>
            </div>)}
            {showSearch && <input className="flex block pl-3 py-3 text-black" type="text" placeholder="Suche" onChange={(e) => setSearch(e.target.value)}/>}
            <div className="flex-1 overflow-auto divide-y divide-gray-700" onScroll={scroll}>
                {sortItems(items).map((item) => <NavLink className="block p-3" activeClassName="bg-gray-600" to={itemLink(item) + location.search} onClick={(_) => setOpen(false)}>
                    <div className="text-sm font-semibold">{(itemTitle??((_)=>''))(item)}</div>
                    <div className="text-xs text-gray-300">{(itemSubtitle??((_)=>''))(item)}</div>
                </NavLink>)}
            </div>
        </div>}
    </div> : <div className="h-full bg-black text-white" id="sidebar_closed">
        <div className="m-2 p-2 font-semibold" onClick={(_) => {setOpen(true);handleMenuClick()}}>
            ☰
        </div>
    </div>;
}